// extracted by mini-css-extract-plugin
export default {"customer":"csr5y5","customer-name":"RlijJh","customerName":"RlijJh"};